import React from "react";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
/* import 'bootstrap/dist/css/bootstrap.min.css'; */
import Home from "./components/Home.js";
import Contacto from "./components/Contacto.js";
import ScrollToTop from "./components/Sub/ScrollToTop"

function App() {
    return (
        <Router>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/Contacto" element={<Contacto />} />
            </Routes>
        </Router>
    );
}



export default App;
